import React from 'react'
import cx from 'classnames'
import PropTypes from 'prop-types'
import { Switch, Route } from 'react-router-dom'
//import PerfectScrollbar from 'perfect-scrollbar'
import { Query } from 'react-apollo'
import { ToastContainer } from 'react-toastify'
import moment from 'moment'
import NotifichePromemoria from './NotifichePromemoria'

import me from 'graphql/queries/me'

// material-ui components
import Group from 'material-ui-icons/Group'
import withStyles from 'material-ui/styles/withStyles'

// components
import Home from './Home/Home.jsx'
import Agenti from './Agenti/Agenti.jsx'
import DettaglioAgente from './Agenti/DettaglioAgente.jsx'
import Pubblicita from './Pubblicita/Pubblicita.jsx'
import Calendario from 'views/App/Calendario/Calendario.jsx'
import CalendarioGiorno from 'views/App/CalendarioGiorno/CalendarioGiorno.jsx'
import Clienti from 'views/App/Clienti/Clienti.jsx'
import ClientiNonRisposto from 'views/App/Clienti/ClientiNonRisposto.jsx'
import DettaglioCliente from './Clienti/DettaglioCliente.jsx'
import NuovoCliente from './Clienti/NuovoCliente.jsx'
import Promemoria from 'views/App/Promemoria/Promemoria.jsx'
import Coupon from './Coupon/Coupon'

// core components
import Header from 'components/Header/Header.jsx'
import Footer from 'components/Footer/Footer.jsx'
import Sidebar from 'components/Sidebar/Sidebar.jsx'

// routes
import dashboardRoutes from 'routes/dashboard.jsx'
import detailRoutes from 'routes/detail.jsx'
import agentRoutes from 'routes/agent.jsx'

// style
import appStyle from 'assets/jss/material-dashboard-pro-react/layouts/dashboardStyle.jsx'
//import 'perfect-scrollbar/css/perfect-scrollbar.css'

// images
import image from 'assets/img/sidebar-2.jpg'
import logo from 'assets/img/logo-cdp.svg'

const switchRoutes = (
  <Switch>
    <Route path="/home" component={Home} />
    <Route exact path="/pubblicita" component={Pubblicita} />
    <Route exact path="/agenti" component={Agenti} />
    <Route path="/agenti/:id" component={DettaglioAgente} />
    <Route exact path="/clienti" component={Clienti} />
    <Route exact path="/non-risposto" component={ClientiNonRisposto} />
    <Route path="/clienti/:id" component={DettaglioCliente} />
    <Route path="/nuovo-cliente" component={NuovoCliente} />
    <Route exact path="/calendario" component={Calendario} />
    <Route exact path="/impegni-giorno" component={CalendarioGiorno} />
    <Route exact path="/promemoria" component={Promemoria} />
    <Route exact path="/coupon" component={Coupon} />
  </Switch>
)

const headerRoutes = detailRoutes.concat(dashboardRoutes)

var ps

class App extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      mobileOpen: false,
      miniActive: false,
    }
  }

  componentDidMount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   // eslint-disable-next-line
    //   ps = new PerfectScrollbar(this.refs.mainPanel, {
    //     suppressScrollX: true,
    //     suppressScrollY: false
    //   })
    // }
  }

  componentWillUnmount() {
    // if (navigator.platform.indexOf("Win") > -1) {
    //   ps.destroy()
    //   ps = null
    // }
  }

  componentDidUpdate(e) {
    if (e.history.location.pathname !== e.location.pathname) {
      this.refs.mainPanel.scrollTop = 0
      //setTimeout(() => { ps.update() }, 2000)
    }
  }

  handleDrawerToggle = () => {
    this.setState({
      mobileOpen: !this.state.mobileOpen,
    })
  }

  sidebarMinimize() {
    this.setState({ miniActive: !this.state.miniActive })
  }

  render() {
    const { classes, ...rest } = this.props
    const agentRoutesExtended = [...agentRoutes]

    const mainPanel =
      classes.mainPanel +
      ' ' +
      cx({
        [classes.mainPanelSidebarMini]: this.state.miniActive,
        // [classes.mainPanelWithPerfectScrollbar]: navigator.platform.indexOf("Win") > -1
      })

    return (
      <div className={classes.wrapper}>
        <ToastContainer />

        <Query
          query={me}
          variables={{
            promemoriaWhere: {
              promemoriaDismesso: false,
              promemoriaDataOra_lte: moment().format('YYYY-MM-DD HH:mm'),
            },
          }}
          fetchPolicy="cache-and-network"
          pollInterval={180000}
        >
          {({ loading, error, data: { me } }) => {
            if (loading || error) {
              return null
            }

            // Marco può vedere le statistiche
            // agenti anche se è agente
            if (me.mostraStatisticheAgenti) {
              agentRoutesExtended.push({
                path: '/agenti',
                name: 'Agenti',
                icon: Group,
                component: Agenti,
              })
            }

            return (
              <div>
                {me.ruolo === 'AGENTE' || me.ruolo === 'SEGRETARIA' ? (
                  <NotifichePromemoria promemoria={me.promemoria} />
                ) : null}

                <Sidebar
                  routes={me.ruolo !== 'AGENTE' ? dashboardRoutes : agentRoutesExtended}
                  logoText={'Case del Parco'}
                  logo={logo}
                  image={image}
                  handleDrawerToggle={this.handleDrawerToggle}
                  open={this.state.mobileOpen}
                  color="primary"
                  bgColor="black"
                  miniActive={this.state.miniActive}
                  {...rest}
                />
              </div>
            )
          }}
        </Query>

        <div className={mainPanel} ref="mainPanel">
          <Header
            sidebarMinimize={this.sidebarMinimize.bind(this)}
            miniActive={this.state.miniActive}
            routes={headerRoutes}
            handleDrawerToggle={this.handleDrawerToggle}
            {...rest}
          />
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>

          <Footer fluid />
        </div>
      </div>
    )
  }
}

App.propTypes = {
  classes: PropTypes.object.isRequired,
}

export default withStyles(appStyle)(App)



// WEBPACK FOOTER //
// ./src/views/App/App.jsx